export { default } from "./Ingredientes";
